module["exports"] = [
  "Norge"
];
